class FAQAccordion {
    constructor() {
        this.accordionItems = document.querySelectorAll('.faq__accordion-item');
        this.init();
    }

    init() {
        this.accordionItems.forEach(item => {
            const title = item.querySelector('.faq__accordion-title');
            const content = item.querySelector('.faq__accordion-content');
            const chevron = item.querySelector('.icon-faq svg');

            // Initially hide all content
            content.style.display = 'none';

            title.addEventListener('click', () => {
                // Toggle the active state
                const isActive = item.classList.contains('active');

                // Close all other accordions
                this.accordionItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('active');
                        otherItem.querySelector('.faq__accordion-content').style.display = 'none';
                        otherItem.querySelector('.icon-faq svg').style.transform = 'rotate(180deg)';
                    }
                });

                // Toggle current accordion
                if (!isActive) {
                    item.classList.add('active');
                    content.style.display = 'block';
                    chevron.style.transform = 'rotate(0deg)';
                } else {
                    item.classList.remove('active');
                    content.style.display = 'none';
                    chevron.style.transform = 'rotate(180deg)';
                }
            });
        });
    }
}

// Initialize the FAQ accordion when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new FAQAccordion();
}); 